import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en.json';
import fr from './i18n/fr.json';

export const resources = {
	en: { translation: en },
	fr: { translation: fr },
} as const;

i18n.use(initReactI18next)
	.use(detector)
	.init({
		resources,
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false,
		},
	});
